<template>
  <div id="subscribe" class="bg-whitesmoke relative pt-32 lg:pt-44 pb-80 md:pb-52 lg:pb-96">
    <div class="container px-16 md:px-32 md:py-20">
      <div class="block lg:flex justify-between">
        <div class="w-full">
          <p class="uppercase text-xl lg:text-2xl font-bold mb-16">Be in the know</p>
          <p class="text-base lg:text-xl">Get the latest art updates by subscribing</p>
        </div>
        <div class="w-full flex items-center">
          <form @submit.prevent="submitData" class="w-full block lg:flex justify-end gap-20 md:mt-22 lg:mt-0">
            <div class="w-full lg:w-6/12 form-group py-22 md:py-0 md:mb-22 lg:mb-0">
              <input type="email" id="email" v-model="email" placeholder="Email Address" class="w-full py-18 px-20 rounded border border-gray outline-none" required/>
            </div>
            <button type="submit" class="w-full lg:w-3/12 py-18 bg-orange text-white px-32 rounded-lg focus:outline-none">Subscribe</button>
          </form>
        </div>
      </div>
    </div>
    <div class="wave-container bottom-0"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      api: '/web/api/subscriptions/subscribe',
      email: '',
    }
  },

  methods: {
    submitData() {
      axios.post(this.api, {email: this.email})
        .then(({data: {data}}) => {
          this.$root.$refs.notification.notify({
            title: 'Success',
            message: data.message,
            type: 'warning-dark',
          })
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.$root.$refs.notification.notify({
              title: 'Error',
              message: error.response.data.errors.email[0],
              type: 'warning-dark',
            })
          }
        })
    }
  }
};
</script>

<style>
@import "../../../css/components/wavy-border.css";
</style>
